// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__QGr0Y","colMaxWidth":"Table_colMaxWidth__2Mqlg"};